import { privateRequest } from "../../axios";
import type { AddPurchaseOrderResponse, AddPurchseOrderPayload, GetPurchaseOrderRequest, ProductDropdown, Root } from "./purchaseOrder.interface";
const ENDPOINTS = {
  PURCHASE_ORDER: "/api/Purchase",
  PRODUCT_LIST:"/api/Products",
  ProductMasterList : "/api/Manufacturer/Products"
};

const getPurchaseOrder = async (params: GetPurchaseOrderRequest) => {
  // For POST with query params: pass empty body {} and params in config
  const response = await privateRequest.get<Root>(ENDPOINTS.PURCHASE_ORDER, 
    {params},
  );
  return response?.data;
};
const addPurchaseOrder  = async (data: AddPurchseOrderPayload) => {
  const response = await privateRequest.post<AddPurchaseOrderResponse>(
    ENDPOINTS.PURCHASE_ORDER,
    data
  );
  return response?.data;
};
// const updateStock = async (id: Number, data: AddStockPyload) => {
//   const response = await privateRequest.put<AddStockResponse>(
//     ENDPOINTS.STOCK_ID(id),
//     data
//   );
//   return response?.data;
// };
// const deleteStock = async (id: Number) => {
//   const response = await privateRequest.delete<AddStockResponse>(
//     ENDPOINTS.STOCK_ID(id)
//   );
//   return response?.data;
// };
const getProductList = async (data: any) => {
  const response = await privateRequest.get<ProductDropdown>(ENDPOINTS.PRODUCT_LIST, data);
  return response?.data;
};

const getProductMasterList = async (data: any) => {
  const response = await privateRequest.get<ProductDropdown>(ENDPOINTS.ProductMasterList, data);
  return response?.data;
};

const PurchaseOrderService = {
  getPurchaseOrder,
  addPurchaseOrder,
  getProductList,
  getProductMasterList
};

export default PurchaseOrderService;
